import { UserWithMyRooms } from "@api/src/types/user";
import { RoomType } from "@prisma/client";

export default function getRoomName(room?: UserWithMyRooms["rooms"][number]) {
  if (room?.room.roomType === RoomType.DIRECT) {
    if (!room) return "";
    if (room.room?.manualName) {
      return room.room.manualName;
    }
    if (room.name) {
      return room.name?.split("__").join(", ").split("_").join(" ");
    }
    return "";
  }
  if (room?.room.manualName) {
    return room.room.manualName;
  }
  if (room?.room.name?.startsWith("CHU")) {
    return `${room?.room.name} & périph`;
  }
  return room?.room.name ?? "";
}
